import React from "react";
import { connect } from "react-redux";
import ContentEditable from "react-contenteditable";
import {
  Row,
  Col,
  Input,
  FormFeedback,
  UncontrolledPopover,
  Button,
  PopoverBody,
} from "reactstrap";
import { labelAlignment } from "../../../helpers/labelAlignment";
import FakeInput from "../../../../components/UI/Input/FakeInput";
import { inputValidator } from "../../../../helpers/inputVaildator";
import IsRequiredSymbol from "../../../../components/UI/Form/IsRequiredSymbol";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { conditionActions } from "../../../../store/actions/cms/condition.action";
import Select from "react-select";
import SelectAddItem from "../../../components/selects/SelectAddItem";
import { deepClone, toCamelCase } from "../../../../helpers/objectHelper";
import { CountryList } from "../../../../system/CountryList/CountryList";
import { attendeeActions } from "../../../../store/actions/attendee/attendee.action";

class Field extends React.Component {
  componentDidMount() {
    if (
      this.props.updateValidator &&
      typeof this.props.updateValidator === "function"
    ) {
      this.props.updateValidator(this.updateValidator);
    }
  }
  componentDidUpdate(prevProps){
    if(this.props.attendee.activePersonNo != prevProps.attendee.activePersonNo){
      this.validateField();
    }
  }
  isChangeLocked = () => {
    const { element, attendee } = this.props;
    if (attendee && attendee.orders && attendee.orders.length > 0 && this.props.attendee.orders[0].orderId !== undefined && element.data.changeLock) {
      return true;
    }
    return false;
  }
  updateValidator = () => {
    if (
      this.props.getValidator &&
      typeof this.props.getValidator === "function"
    ) {
      this.props.getValidator(() => this.validateField());
    }
  }
  validateField = () => {
    let input = this.getFieldValue();
    const element = deepClone(this.props.element);
    let isValid = true;
    if (element.props.labels[0].text === 'Avdelning') {
    }
    if (element.data.readOnly || element.data.hidden) {
      isValid = true;
      return isValid;
    }

    if (element.data.required === true && input.length === 0) {
      isValid = false;
    }

    if (input !== null) {
      isValid = (input && input.length >= element.props.length) ||
        (input === '' && element.props.length === 0)/*  ? true : false */;
      if (isValid && element.data.validation.type !== "none") {
        isValid = inputValidator(input, element.data.validation.type);
      }
    }
    if ((this.props.element.props.name == 'CountryId' && !isNaN(parseInt(input)) && parseInt(input) > 0) || (this.props.element.props.name == 'CountryId' && input == 0)) {
       isValid = true;
    }
    if (this.props.element.isValid !== isValid) {
      element.isValid = isValid;
      this.handleUpdate(element);
    }
    return isValid;
  };
  handleUpdate = element => {
    const { dispatch, cms } = this.props;
    element.forceValidationMessage = false;
    dispatch(formActions.updateFormElement(element));
    if (!cms.editMode) {
      dispatch(conditionActions.triggerCheck(element.formElementId));
    }
  };

  handleChange(e, path) {
    const { form } = this.props;
    const names = path.split(".");
    const element = deepClone(this.props.element);
    if (names[1] === "labels") {
      element.props.labels.map(l => {
        if (l.languageCode === form.languageCode) {
          l.text = e.target.value;
        }
      });
    } else if (names[1] === "subInputs") {
      element.props.subInputs.map(l => {
        if (l.languageCode === form.languageCode) {
          l.text = e.target.value;
        }
      });
    } else if (names[1] === "subLabels") {
      element.props.subLabels.map(l => {
        if (l.languageCode === form.languageCode) {
          l.text = e.target.value;
        }
      });
    } else {
      element[names[0]][names[1]] = e.target.value;
    }
    this.handleUpdate(element);
  }

  componentWillUnmount() {
    if (
      this.props.updateValidator &&
      typeof this.props.updateValidator === "function"
    ) {
      this.props.updateValidator(this.updateValidator, true);
    }
  }
  getFieldLabels = () => {
    const { form, element } = this.props;
    const fieldLabel =
      element &&
      element.props.labels &&
      element.props.labels.find(l => {
        return l.languageCode === form.languageCode && l.text ? l : "";
      });
    const fieldSubLabel =
      element &&
      element.props.subLabels &&
      element.props.subLabels.find(l => {
        return l.languageCode === form.languageCode && l.text ? l : "";
      });
    const fieldSubInput =
      element &&
      element.props.subInputs &&
      element.props.subInputs.find(l => {
        return l && l.languageCode === form.languageCode && l.text ? l : "";
      });

    return { fieldLabel, fieldSubInput, fieldSubLabel };
  };
  handleSelectOnChange = (o, path, /* el, lang */) => {
    this.handleValueChange(o.value)
  };
  handleOptionEdit = (value, index) => {
    const element = deepClone(this.props.element);
    element.data.selectOptions.splice(index, 1, {
      value: value,
      sortOrder: index + 1
    });
    this.handleUpdate(element);
  };
  addOptions = value => {
    const element = deepClone(this.props.element);
    const sortOrder =
      element.data.selectOptions.length > 0
        ? element.data.selectOptions.length + 1
        : 1;
    element.data.selectOptions.push({ value: value, sortOrder: sortOrder });

    this.handleUpdate(element);
  };
  addListOptions = value => {
    const options = value.split("\n");
    const element = deepClone(this.props.element);
    options.map(o => {
      if (o !== "") {
        let sortOrder =
          element.data.selectOptions.length > 0
            ? element.data.selectOptions.length + 1
            : 1;
        element.data.selectOptions.push({ value: o, sortOrder: sortOrder });
      }
    });
    this.handleUpdate(element);
  };
  removeOption = index => {
    const element = deepClone(this.props.element);
    element.data.selectOptions.splice(index, 1);
    element.data.selectOptions.sort().map((o, i) => {
      let opt = deepClone(o);
      opt.sortOrder = i + 1;
      return opt;
    });
    this.handleUpdate(element);
  };

  handleOrderChange = (event, dataSource) => {
    const element = deepClone(this.props.element);
    const sortedOptions = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i + 1;
      return el;
    });
    element.data.selectOptions = sortedOptions;
    this.handleUpdate(element);
  };
  sortOptions = () => {
    if (this.props.element.data.selectOptions.length === 0) return [];
    if (this.props.element.data.sortType === "ALPHA") {
      return this.props.element.data.selectOptions.sort(function (a, b) {
        var textA = a.value.toUpperCase();
        var textB = b.value.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    }
    return this.props.element.data.selectOptions.sort(function (a, b) {
      let x = a.sortOrder;
      let y = b.sortOrder;
      return y < x ? 1 : y > x ? -1 : 0;
    });
  };
  handleValueChange = (value/* , lang = null */) => {
    const { element, attendee, dispatch, cms } = this.props;
    if (attendee && attendee.orders) {
  /*     if(lang){
        attendee.orders.languageCode = lang.toLowerCase();
      } */
      let order = attendee.orders[attendee.activePersonNo];

      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase(element.props.type)];
      let newType = undefined;
      if (!type) {
        newType = {};
      } else {
        newType = deepClone(type);
      }
      newType[toCamelCase(element.props.name)] = value;
      newOrder[toCamelCase(element.props.type)] = newType;
      dispatch(attendeeActions.updateOrder(newOrder, attendee.activePersonNo));
    }
    clearTimeout(this.validateTimeout);
    this.validateTimeout = setTimeout(() => {
      this.validateField()
      if (!cms.editMode) {
        dispatch(conditionActions.triggerCheck(element.formElementId));
      }
    }, 200);
  };
  getFieldValue = () => {
    const { element, attendee } = this.props;
    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = attendee.orders[attendee.activePersonNo];
      let type = order[toCamelCase(element.props.type)];
      if (type) {
        let val = type[toCamelCase(element.props.name)];
        if (val) {
          return val;
        }
      }
    }
    return "";
  };

  render() {
    const { form, selectedElement, cms, element, } = this.props;
    const { template, previewDevice } = this.props.template;
    const { fieldLabel, fieldSubInput, fieldSubLabel } = this.getFieldLabels();
    let isReadOnly = element.data.readOnly || (!cms.editMode && this.isChangeLocked());
    if (element && element.data && element.data.hidden && !cms.editMode)
      return null;

    return (
      <div
        style={{
          width: "100%",
          padding: element.data && element.data.padding + "px"
        }}
        id={element.contentId}
      >
        {element.data.hidden && (
          <div className="hidden-element">
            <i className="fa fa-eye-slash hidden-element-icon" />
          </div>
        )}
        <FakeInput />
        <Row
          style={{ flexDirection: labelAlignment(element.data.labelAlign), margin: '0px', display: cms.editMode && previewDevice === 'smartphone' ? 'block' : undefined }}
          className="responsive-row"
        >
          <Col
            className="qs-label-col"
            style={{
              padding: '0px',
              maxWidth: cms.editMode && previewDevice === 'smartphone' ? '100%' :
                (element.data.labelAlign !== "center" &&
                  element.data.titleWidth !== undefined &&
                  element.data.titleWidth + "%"),
              wordBreak: element.data.labelAlign !== "center" && "break-word",
              paddingTop: '5px'
            }}
          >
            <div style={{ display: "inline-flex", width: "100%" }}>
              <ContentEditable
                style={
                  template
                    ? {
                      ...template.content.label,
                      marginRight: "5px",
                      wordBreak: "break-word"
                    }
                    : {
                      wordBreak: "break-word"
                    }
                }
                innerRef={this.contentEditable}
                html={fieldLabel && fieldLabel.text}
                disabled={!form.editMode}
                onChange={e => this.handleChange(e, "props.labels")}
                tagName="label"
              />
              <IsRequiredSymbol
                condition={element.props.length > 0 || element.data.required}
              />
            </div>
            {element.data.showSubLabel && (
              <ContentEditable
                innerRef={this.contentEditable}
                html={fieldSubLabel !== undefined ? fieldSubLabel.text : ""}
                style={{
                  color: template !== undefined && template.content.text.color,
                  fontFamily:
                    template !== undefined && template.content.text.fontFamily,
                  fontSize:
                    template !== undefined && template.content.text.fontSize,
                  backgroundColor:
                    this.props.selectedElement &&
                    this.props.selectedElement.contentId ===
                    element.contentId &&
                    "whitesmoke",
                  wordBreak: "break-word"
                }}
                disabled={!form.editMode}
                onChange={e => this.handleChange(e, "props.subLabels")}
                tagName="p"
              />
            )}
          </Col>
          <Col
            className="responsive-input-slot"
            style={{
              padding: '0px',
              maxWidth: cms.editMode && previewDevice === 'smartphone' ? '100%' : (
                element.data.labelAlign !== "center" &&
                element.data.inputWidth !== undefined &&
                element.data.inputWidth + "%"
              )

            }}
          >
            {element.props.name === "CountryId" ? (
              <React.Fragment>
                <div
                  className="responsive-input"
                  style={{ width: cms.editMode && previewDevice === 'smartphone' ? '100%' : (element.data.style.width.toString().includes('%') ? element.data.style.width : element.data.style.width + '%') }}
                >
                  <CountryList
                    onChange={this.handleSelectOnChange}
                    value={this.getFieldValue()}
                    languageCode={this.props.form.languageCode}
                    isReadOnly={isReadOnly}
                    template={template}
                  />
                </div>
                <Input
                  style={{ display: "none" }}
                  valid={element.isValid === true}
                  invalid={element.isValid === false}
                />
                <FormFeedback valid={element.isValid === true}>
                  {element.isValid === false ? element.data.validation.message : null}
                </FormFeedback>
              </React.Fragment>
            ) : null}
            {element.data.displayType === "TEXT" &&
              element.props.name !== "CountryId" ? (
                <React.Fragment>
                  <Input
                    type={"text"}
                    className="responsive-input"
                    onChange={e => this.handleValueChange(e.target.value)}
                    autoComplete="off"
                    autoFocus={false}
                    readOnly={isReadOnly}
                    required={element.data.required || false}
                    value={this.getFieldValue()}
                    style={
                      template && {
                        ...template.content.input,
                        width: cms.editMode && previewDevice === 'smartphone' ? '100%' : (element.data.style.width.toString().includes('%') ? element.data.style.width : element.data.style.width + '%'),
                        wordBreak: "break-word",
                        opacity: isReadOnly ? template.content.input.readOnlyOpacity : 1,
                        fontSize: template.content.input.fontSize /* + ' !important' */

                      }
                    }
                    maxLength={element.data.maxCharacters}
                    valid={element.isValid === true}
                    invalid={element.isValid === false}
                  />
                  <FormFeedback valid={element.isValid === true}>
                    {element.isValid === false ? element.data.validation.message : null}
                  </FormFeedback>
                </React.Fragment>
              ) : null}
            {element.data.displayType === "SELECT" &&
              element.props.name !== "CountryId" ? (
                <React.Fragment>
                  <div
                    className="responsive-input"
                    style={{ width: cms.editMode && previewDevice === 'smartphone' ? '100%' : (element.data.style.width.toString().includes('%') ? element.data.style.width : element.data.style.width + '%'), }}
                  >
                    {/*           <p>{element.props.Name }</p> */}
                    <Select
                      onChange={selectedOption =>
                        this.handleValueChange(selectedOption.value)
                      }
                      isDisabled={element.data.readOnly || false}
                      options={this.sortOptions().map((so, i) => {
                        return { value: so.value, label: so.value };
                      })}
                      placeholder=""
                      styles={{
                        control: styles => ({
                          ...styles,
                          borderColor:
                            (template !== undefined &&
                              template.content.input.borderColor) ||
                            "unset",
                          borderRadius:
                            (template !== undefined &&
                              template.content.input.borderRadius) ||
                            "unset",
                          fontFamily:
                            (template !== undefined &&
                              template.content.input.fontFamily) ||
                            "unset",
                          fontWeight:
                            (template !== undefined &&
                              template.content.input.fontWeight) ||
                            "unset",
                          margin:
                            (template !== undefined &&
                              template.content.input.margin) ||
                            "unset",
                          boxShadow:
                            (template !== undefined &&
                              template.content.input.boxShadow) ||
                            "unset",
                          fontSize:
                            (template !== undefined &&
                              template.content.input.fontSize) ||
                            "unset",
                          color:
                            (template !== undefined &&
                              template.content.input.color) ||
                            "unset",
                          backgroundColor:
                            (template !== undefined &&
                              template.content.input.backgroundColor) ||
                            "unset",
                          maxWidth: "100%"
                        }),
                        menu: styles => ({
                          ...styles,
                          maxWidth: "100%"
                        }),
                        input: styles => ({
                          ...styles,
                          fontSize:
                            (template !== undefined &&
                              template.content.input.color) ||
                            "unset",
                          fontFamily:
                            (template !== undefined &&
                              template.content.input.fontFamily) ||
                            "unset"
                        }),
                        singleValue: styles => ({
                          ...styles,
                          fontSize:
                            (template !== undefined &&
                              template.content.input.color) ||
                            "unset",
                          fontFamily:
                            (template !== undefined &&
                              template.content.input.fontFamily) ||
                            "unset"
                        }),
                        option: styles => ({
                          ...styles,
                          fontSize:
                            (template !== undefined &&
                              template.content.input.color) ||
                            "unset",
                          fontFamily:
                            (template !== undefined &&
                              template.content.input.fontFamily) ||
                            "unset"
                        }),
                        placeholder: styles => ({
                          ...styles,
                          fontSize:
                            (template !== undefined &&
                              template.content.input.color) ||
                            "unset",
                          fontFamily:
                            (template !== undefined &&
                              template.content.input.fontFamily) ||
                            "unset"
                        })
                      }}
                      value={element.data.selectOptions.find(t => {
                        return t.value === element.data.text;
                      })}
                    />
                  </div>

                  <Input
                    style={{ display: "none" }}
                    valid={element.isValid === true}
                    invalid={element.isValid === false}
                  />
                  <FormFeedback valid={element.isValid === true}>
                    {element.isValid === false ? element.data.validation.message : null}
                  </FormFeedback>
                  {cms.editMode &&
                    selectedElement &&
                    element &&
                    selectedElement.contentId === element.contentId ? (
                      <React.Fragment>
                        <Button
                          id="EditOptions"
                          type="button"
                          style={{
                            color: "#222",
                            fontFamily: "unset",
                            backgroundColor: "inherit",
                            border: "none"
                          }}
                        >
                          <i className="fa fa-plus" />{" "}
                          <SystemLabel name="AddOption" />
                        </Button>

                        <UncontrolledPopover
                          style={{
                            backgroundColor: "#2f353a",
                            minWidth: "30vw",
                            maxHeight: "35vh"
                          }}
                          placement="bottom"
                          trigger="legacy"
                          target="EditOptions"
                        >
                          <PopoverBody>
                            <SelectAddItem
                              options={element.data.selectOptions}
                              onEdit={this.handleOptionEdit}
                              onAdd={this.addOptions}
                              onDelete={this.removeOption}
                              onListAdd={this.addListOptions}
                              onOrderChange={this.handleOrderChange}
                            />
                          </PopoverBody>
                        </UncontrolledPopover>
                      </React.Fragment>
                    ) : null}
                </React.Fragment>
              ) : null}

            {element.data.showSubInput && (
              <ContentEditable
                innerRef={this.contentEditable}
                html={fieldSubInput !== undefined ? fieldSubInput.text : ""}
                style={{
                  color: template !== undefined && template.content.text.color,
                  fontFamily:
                    template !== undefined && template.content.text.fontFamily,
                  fontSize:
                    template !== undefined && template.content.text.fontSize,
                  backgroundColor:
                    this.props.selectedElement &&
                    this.props.selectedElement.contentId ===
                    element.contentId &&
                    "whitesmoke",
                  wordBreak: "break-word"
                }}
                disabled={!form.editMode}
                onChange={e => this.handleChange(e, "props.subInputs")}
                tagName="p"
              />
            )}
          </Col>
        </Row >
      </div >
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedElement: state.form.selectedElement,
    form: state.form,
    event: state.event,
    template: state.template,
    rElement: state.element,
    cms: state.cms,
    attendee: state.attendee
  };
}

export default connect(mapStateToProps)(Field);
